module.exports = "https://portperrypedals.ca/_res/img/partsman.a9c118c.png";